import { useMemo } from "react";

export const avatarColor = (name) => {
  let h = 7;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return `hsl(${h} 80% 60%)`;
};

export const Avatar = ({ name, size = "md", dead }) => (
  <span className={`avatar avatar-${size}${dead ? " is-dead" : ""}`} style={{ "--av": avatarColor(name) }} aria-hidden="true">
    {name.trim().charAt(0).toUpperCase()}
  </span>
);

export const vibrate = (p) => {
  try { navigator.vibrate && navigator.vibrate(p); } catch { /* sin soporte */ }
};

const SOUNDS = {
  tap: [[660, 0.05, "triangle"]],
  reveal: [[440, 0.08, "sine"], [880, 0.18, "sine"]],
  tick: [[1000, 0.05, "square"]],
  time: [[300, 0.35, "sawtooth"]],
  eliminate: [[220, 0.15, "sawtooth"], [110, 0.4, "sawtooth"]],
  win: [[523, 0.12, "triangle"], [659, 0.12, "triangle"], [784, 0.3, "triangle"]],
  lose: [[300, 0.2, "sawtooth"], [200, 0.2, "sawtooth"], [120, 0.5, "sawtooth"]],
};
let ctx;
export const playSound = (kind, on) => {
  if (!on || !SOUNDS[kind]) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    let t = ctx.currentTime;
    for (const [f, d, type] of SOUNDS[kind]) {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = type;
      o.frequency.value = f;
      g.gain.setValueAtTime(0.12, t);
      g.gain.exponentialRampToValueAtTime(0.001, t + d);
      o.connect(g).connect(ctx.destination);
      o.start(t);
      o.stop(t + d);
      t += d * 0.9;
    }
  } catch { /* audio no disponible */ }
};

export const Switch = ({ checked, onChange, label, testid }) => (
  <button type="button" role="switch" aria-checked={checked} className="switch-row" onClick={() => onChange(!checked)} data-testid={testid}>
    <span>{label}</span>
    <span className={`switch${checked ? " on" : ""}`}><i /></span>
  </button>
);

export const Segmented = ({ options, value, onChange, testid }) => (
  <div className="segmented" data-testid={testid}>
    {options.map((o) => (
      <button key={o.value} type="button" disabled={o.disabled} className={value === o.value ? "active" : ""} onClick={() => onChange(o.value)} data-testid={`${testid}-${o.value}`}>
        {o.label}
      </button>
    ))}
  </div>
);

export const Modal = ({ text, confirmLabel, onConfirm, onCancel }) => (
  <div className="modal-backdrop" onClick={onCancel} data-testid="confirm-modal">
    <div className="modal glass" onClick={(e) => e.stopPropagation()}>
      <p className="modal-text">{text}</p>
      <div className="modal-actions">
        <button className="btn btn-ghost" onClick={onCancel} data-testid="confirm-cancel-btn">Cancelar</button>
        <button className="btn btn-danger" onClick={onConfirm} data-testid="confirm-accept-btn">{confirmLabel}</button>
      </div>
    </div>
  </div>
);

const CONFETTI_COLORS = ["var(--accent)", "var(--accent-2)", "var(--inocente)", "#facc15", "#f472b6"];
export const Confetti = () => {
  const pieces = useMemo(() => Array.from({ length: 90 }, (_, i) => ({
    left: Math.random() * 100,
    delay: Math.random() * 1.2,
    dur: 2.4 + Math.random() * 2,
    rot: Math.random() * 720 - 360,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    w: 6 + Math.random() * 6,
  })), []);
  return (
    <div className="confetti" aria-hidden="true" data-testid="confetti">
      {pieces.map((p, i) => (
        <i key={i} style={{ left: `${p.left}%`, animationDelay: `${p.delay}s`, animationDuration: `${p.dur}s`, background: p.color, width: p.w, "--rot": `${p.rot}deg` }} />
      ))}
    </div>
  );
};

export const Dots = ({ total, current }) => (
  <div className="dots" data-testid="progress-dots">
    {Array.from({ length: total }, (_, i) => (
      <span key={i} className={i < current ? "done" : i === current ? "current" : ""} />
    ))}
  </div>
);
